module.exports = __webpack_public_path__ + "static/media/game-die.67d6c8d8.png";